import React from 'react';
import BacklogMetaPlanDataAPIConsumer from './rest-backlog-data/index.tsx';
import BacklogMetaAPIConsumer from './swag-backlog-data/index.tsx';

type Props = {
	isCompanyManaged: boolean;
};

const BacklogMetaAPIConsumerWrapper = ({ isCompanyManaged }: Props) => {
	if (isCompanyManaged) {
		return <BacklogMetaPlanDataAPIConsumer />;
	}
	return <BacklogMetaAPIConsumer />;
};

export default BacklogMetaAPIConsumerWrapper;
